<script setup lang="ts">
import {useRoute} from "vue-router";
import {onMounted} from "vue";
import {useOrderStore} from "../../store/orders";
import EmptyState from "../../components/global/EmptyState.vue";
import {ref} from "vue";
import OrderHistoryDay from "../../components/orders/OrderHistoryDay.vue";
import {useModalStore} from "../../store/modal";
import {useChatStore} from "../../store/chat";
import {useRouter} from "vue-router";

const route = useRoute()
const store = useOrderStore()
const modalStore = useModalStore()
const chatStore = useChatStore()
const client_contact = ref()
const solution = ref()
const location = ref()
const cart = ref()

const createCall = () => {
    modalStore.open('CreateCall', {uuid: store?.order?.uuid}, 'body', 'bottom-right')
}
const dormantOrder = () => {
    modalStore.open('DormantOrder', {uuid: store?.order?.uuid}, 'body', 'bottom-right')
}
const unprocessOrder = () => {
    modalStore.open('UnprocessOrder', {uuid: store?.order?.uuid}, 'body', 'bottom-right')
}

const createChat = async () => {
    modalStore.open('CreateChat', {uuid: store?.order?.uuid}, 'body', 'bottom-right')
}

onMounted(async () => {
    await store.getOrder(route.params.id)
    await store.getStatuses()

    cart.value = store.order.cart
    client_contact.value = store.order.cart.client_contact
    solution.value = store.order.cart.solution
    location.value = store.order.cart.location
})

</script>

<template>
    <main v-if="!store.order">
        <empty-state icon="speechbubble-double" heading="Loading order." content="Give it sec, it's coming in a mo."/>
    </main>

    <main v-else>
        <section>
            <div class="section-header">
                <div>
                    <a class="back-button" href="#" @click.prevent="$router.back()">
                        <ah-icon name="arrow-left"/>
                    </a>
                    <h1>{{ store.order.uuid }}</h1>

                    <div class="status-badge">
                        {{ store.order.status }}
                    </div>
                </div>
                <div>


                    <BrandButton variant="small" v-if="store.order.cart.client_solutions && store.pending_statuses.includes(store.order.status)" as="button"
                                 @click="dormantOrder()">
                        <span>Dormant Order</span>
                        <ah-icon name="cross-default"/>
                    </BrandButton>

                    <BrandButton variant="small" v-if="store.order.cart.client_solutions && store.pending_statuses.includes(store.order.status)" as="button"
                                 @click="unprocessOrder()">
                        <span>Unprocess Order</span>
                        <ah-icon name="cross-default"/>
                    </BrandButton>
                </div>
            </div>

            <div class="section-header-actions" v-if="store.order.cart.client_solutions">
                <BrandButton variant="primary" as="button"
                             @click="createCall()">
                    <span>Call</span>
                    <ah-icon name="call-default" color="#FFF"/>
                </BrandButton>

                <BrandButton as="button" @click="createChat()">
                    <span>Chat</span>
                    <ah-icon name="speechbubble-sms" color="#FFF"/>
                </BrandButton>

                <BrandButton variant="primary" as="a"
                             :href="`https://mojo.afrihost.com/en/manage/${store.order.cart.client_solutions.find(s => s.product_type === 'solution_composite_fibre').id}`"
                             target="_blank">
                    <span>Mojo Profile</span>

                    <ah-icon name="grid-other" color="#FFF"/>
                </BrandButton>
            </div>

            <div class="section-body">
                <div class="section-body-column">
                    <div class="section-card">
                        <div class="section-card-header">
                            <p>Client details.</p>
                        </div>

                        <div class="section-card-body">
                            <div class="section-card-body-row">
                                <div class="section-card-detail">
                                    <p class="section-card-detail-label">Full name.</p>
                                    <p class="section-card-detail-value">
                                        {{ `${client_contact?.first_name} ${client_contact?.last_name}` }}</p>
                                </div>
                                <div class="section-card-detail">
                                    <p class="section-card-detail-label">Cell nr.</p>
                                    <p class="section-card-detail-value">{{ client_contact?.cell_number }}</p>
                                </div>
                            </div>

                            <div class="section-card-body-row">
                                <div class="section-card-detail">
                                    <p class="section-card-detail-label">Email.</p>
                                    <p class="section-card-detail-value">{{ client_contact?.email_address }}</p>
                                </div>
                                <div class="section-card-detail">
                                    <p class="section-card-detail-label">ID.</p>
                                    <p class="section-card-detail-value">{{ client_contact?.id_number }}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="section-card">
                        <div class="section-card-header">
                            <ah-icon
                                :name="solution?.vendor_slug ? `provider-${solution?.vendor_slug}` :  'provider-vuma-reach'"
                                :size="112"/>
                        </div>

                        <div class="section-card-body">
                            <div class="section-card-body-row">
                                <div class="section-card-detail speed-card">
                                    <div class="speed-card-details">
                                        <ah-icon name="arrow-up"/>
                                        <span>{{ Math.ceil(solution?.attributes.speed_upload / 1024) }}Mbps</span>
                                    </div>
                                </div>
                                <div class="section-card-detail speed-card">
                                    <div class="speed-card-details">
                                        <ah-icon name="arrow-down"/>
                                        <span>{{ Math.ceil(solution?.attributes.speed_upload / 1024) }}Mbps</span>
                                    </div>
                                </div>
                            </div>

                            <div class="section-card-detail">
                                <p class="section-card-detail-label">Location.</p>
                                <p class="section-card-detail-value">{{ cart?.address }}</p>
                            </div>
                        </div>
                    </div>


                    <div class="section-card">
                        <div class="section-card-header">
                            <p>Tickets.</p>
                        </div>

                        <div class="section-card-body">
                            <router-link class="section-card-detail" v-for="ticket in store.order.tickets"
                                         :key="ticket.id" :to="`/tickets/view/${ticket.id}`">
                                <div class="section-card-detail-label">
                                    <div class="ticket-details">
                                        <ah-icon name="speechbubble-double"/>
                                        <div class="ticket-number">
                                            <p class="ticket-number-heading">Ticket</p>
                                            <p class="ticket-number-number">#{{ ticket.external_id }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="section-card-detail-value">
                                    <span class="ticket-status">{{ ticket.status.replace('-', ' ') }}</span>
                                    <ah-icon name="chevron-right"/>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="section-body-column">
                    <div class="section-card">
                        <div class="section-card-header">
                            <p>Order history.</p>
                        </div>
                        <div class="section-card-body">
                            <order-history-day :day="day" :items="history"
                                               v-for="(history, day) in store.orderHistory"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>

    <!--    <main v-else>-->
    <!--        <empty-state icon="cart-default" heading="No pending orders." content="Once an order is placed it will show up here." />-->
    <!--    </main>-->
</template>

<style scoped lang="scss">
.section-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2rem;

    div {
        display: flex;
        gap: 2rem;
        align-items: center;

        .back-button {
            width: 3.6rem;
            height: 3.6rem;
            border-radius: 50%;
            background: var(--color-white);
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .status-badge {
            padding: 1.5rem 3rem;
            @include font(1.4, 1.4, black);
            border-radius: 3rem;
            border: .1rem solid var(--color-tiffany-dark);
            color: #009991;
            text-transform: capitalize;
        }

        .brand-button {
            display: flex;
            align-items: center;
            gap: 1rem;

            span {
                font: inherit;
            }
        }

        &:last-child {
            gap: 1rem;
        }
    }

    @include dark() {
        .back-button {
            background: var(--color-darth-maul);

            .icon {
                fill: var(--color-grey-dew);
            }
        }

        .status-badge {
            color: var(--color-white);
            background: rgba(0, 153, 145, .2);
        }

        .brand-button {
            .icon {
                fill: var(--color-grey-dew) !important;
            }
        }

        div {
            h1 {
                color: var(--color-white-100)!important;
            }
        }
    }

    @include mobile() {
        flex-direction: column;
        padding: 0;
        gap: 2rem;

        div {
            width: 100%;

            .brand-button, .status-badge {
                width: 100%;
                justify-content: center;
            }

            .brand-button {
                height: 6rem;
            }

            &:first-child {
                h1 {
                    width: calc(100% - 5.6rem);
                }
            }

            &:last-child {
                flex-direction: column;
            }
        }
    }
}

.section-header-actions {
    display: flex;
    gap: 1rem;
    margin-bottom: 4rem;

    .brand-button {
        display: flex;
        align-items: center;
        gap: 1rem;

        span {
            font: inherit;
        }
    }
}

.section-body {
    display: flex;
    gap: 2rem;
    height: calc(100% - 9rem);
    overflow: hidden;

    .section-body-column {
        flex: 1;
        max-height: 100%;

        .section-card {
            background: var(--color-white);
            padding: 1rem;
            border-radius: 2.4rem;
            display: flex;
            flex-direction: column;
            gap: 1rem;
            height: 100%;

            .section-card-header {
                height: 8.4rem;
                display: flex;
                align-items: center;
                justify-content: center;
                background: var(--color-grey-dew);
                border-radius: 2.4rem;

                p {
                    @include font(2.4, 2.4, black);
                }

                .icon {
                    width: 11.2rem;
                    height: 8rem;
                }
            }

            .section-card-body {
                display: flex;
                flex-direction: column;
                gap: 1rem;

                .section-card-body-row {
                    display: flex;
                    align-items: center;
                    gap: 2rem;

                    div {
                        flex: 1;
                    }
                }

                .section-card-detail {
                    padding: 0 2rem;
                    border-radius: 2.4rem;
                    background: var(--color-grey-mist);
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    height: 6rem;

                    p {
                        @include font(1.4, 1.4, book);
                    }

                    .section-card-detail-label {
                        .ticket-details {
                            display: flex;
                            gap: 2rem;
                            align-items: center;

                            .icon {
                                fill: var(--color-tiffany-dark);
                            }

                            .ticket-number {
                                .ticket-number-heading {
                                    @include font(1, 1, black);
                                    color: var(--color-grey-hazy);
                                }
                            }
                        }
                    }

                    .section-card-detail-value {
                        @include font(1.4, 1.4, black);
                        display: flex;
                        align-items: center;
                        gap: 1rem;

                        .ticket-status {
                            text-transform: capitalize;
                            background: var(--color-white);
                            border-radius: 1.5rem;
                            padding: 0 1.2rem;
                            @include font(1.1, 2.4, black);
                        }

                        .icon {
                            fill: var(--color-grey-hazy);
                        }
                    }

                    &.speed-card {
                        justify-content: center;

                        .speed-card-details {
                            display: flex;
                            gap: 1rem;
                            align-items: center;
                            flex: unset;

                            .icon {
                                fill: var(--color-tiffany-dark);
                            }

                            span {
                                @include font(1.4, 1.4, black);
                            }
                        }
                    }
                }
            }

            &:last-child {
                .section-card-body {
                    height: calc(100% - 10.4rem);
                    overflow: scroll;
                    display: block;

                    .section-card-detail {
                        margin-bottom: 2rem;

                        &:last-child {
                            margin-bottom: 0;
                        }
                    }
                }
            }
        }

        &:first-child {
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: 24.4rem 24.4rem minmax(0, 1fr);
            grid-row-gap: 2rem;
        }

        &:last-child {
            .section-card {
                .section-card-body {
                    display: flex;
                    gap: 1rem;
                }
            }
        }
    }

    @include dark() {
        .section-card {
            background: var(--color-darth-maul);
            color: var(--color-white) !important;

            .section-card-header {
                background: var(--color-darth-vader);

                p {
                    color: var(--color-white);
                }

                .icon {
                    fill: var(--color-white);
                }
            }

            .section-card-body {
                .section-card-detail {
                    background: var(--color-darth-sidious);

                    p {
                        color: var(--color-white);
                    }
                }
            }
        }
    }

    @include mobile() {
        flex-direction: column;
        height: 100%;
        overflow: unset;

        .section-body-column {
            max-height: unset;

            .section-card {
                height: unset;

                .section-card-body {
                    height: auto !important;

                    .section-card-body-row {
                        flex-direction: column;
                        align-items: unset;
                    }
                }

                .section-card-detail {
                    min-height: 6rem;
                    height: unset !important;
                    gap: 2rem;
                    padding: 2rem !important;
                }
            }

            &:first-child {
                display: flex;
                flex-direction: column;
                gap: 2rem;
            }
        }
    }
}
</style>
